// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__6EMQh","Open":"SideDrawer_Open__19zK1","Close":"SideDrawer_Close__3h6ul"};